import React from "react"

import { useState } from "react";
import { useRef } from "react";
import { StaticQuery, graphql, Link } from "gatsby"

//import Menu from "./menu"
import SideBar from "./sidebar"
import styled from 'styled-components'
//import AniLink from "gatsby-plugin-transition-link/AniLink"
import { useLayoutEffect } from 'react'
// import { CategoryColor } from '../utils/CategoryColor'


const HEADER_QUERY =  graphql`
query SiteTitleQuery {
  site {
    siteMetadata {
      title
      description
    }
  }
}
`

const HeaderContainerDiv = styled.div`
header {
  display: flex;
  height: 58px;
  // background: rgba(11,1,53,1);
  justify-content: space-between;
  .title-vertical-logo-container {
    margin-left: auto;
    margin-right: auto;
  }
  a:first-child {
    margin-right: auto;
  }
  & > * {
    display: inline-block;
    flex-grow: 1;
    flex-shrink: 1;
    // background: rgba(11,1,53,1);

    &:first-child, &:last-child {
      flex-grow: 0;
      flex-shrink: 0;
      // background: rgba(11,1,53,1);
    }

    // &:first-child {
    //   // flex-grow: 0;
    //   // flex-shrink: 0;
    //   background: rgba(11,1,53,1);
    // }
  }

  #title-vertical-logo-container {
    display: flex;
    color: white;
    text-transform: uppercase;
    font-weight: 900;
    font-size: 24px;
    line-height: 18px;
    justify-content: flex-start;

    opacity: 0;
    align-items: center;
    > * {
      margin-top: auto;
      margin-bottom: auto;
      margin-left: 1rem;
      margin-right: 1rem;
    }
    &:first-child {
      flex-grow: 1;
      flex-shrink: 1;
    }
    &:last-child {
      flex-grow: 0;
      flex-shrink: 0;
      // flex-base: 100px;
    }

    .vertical-logo {
      min-width: 150px;
      height: 58px;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      filter: brightness(0) invert(1);
    }
  }

  @media only screen and (max-width: 1024px) {
    &.not-is-vertical.is-article {

      justify-content: space-between;
      & :first-child {
        margin-right: auto;
      }

      #title-vertical-logo-container {
        display: none;
      }
    }
  }

  @media only screen and (max-width: 1024px) {
    &.not-is-vertical.is-article.is-search {
      #mobile_mini_logo_only_xs {
        display: none;
      }
      .mag_header_vertical_logo {
        display: block;
      }
    }
  }

  @media only screen and (min-width: 1024px) {

    &.not-is-vertical.is-article {
      display: none;
    }

    &.is-vertical.is-article {
      & > *:first-child {
        display: none;
      }
    }

    &.not-is-article {
      display: none;
    }

    &.is-vertical {
      font-size: 15px;
      height: 29px;
    }

    margin-left: 17%;
    width: 83%;

    & > *:last-child {
      display: none;
    }
    #title-vertical-logo-container {
      justify-content: space-between;
      font-size: 15px;
      .vertical-logo {
        height: 29px;
        min-width: 100px;
      }
    }
  }
  @media only screen and (max-width: 520px) {
    #title-vertical-logo-container {
      font-size: 16px;
      line-height: 18px;
      > * {
        margin-left: 0.5rem;
        margin-right: 0.5rem;
      }

      .vertical-logo {
        min-width: 100px;
      }
    }
  }

  @media only screen and (max-width: 360px) {
    &.not-is-vertical #title-vertical-logo-container {
      display: none;
    }
    &.is-vertical #title-vertical-logo-container {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      font-size: 14px;
      line-height: 12px;
      .vertical-logo {
        height: 24px;
      }
    }

    & > *:last-child {
      margin-left: auto;
    }
  }
}
`


const BurgerButtonBg = styled.div`
@media only screen and (min-width: 1024px) {
  // visibility: hidden;
  // display: none;
}
background: linear-gradient(45deg, #EE3D49 0%, #CB356B 100%);;
height: 100%;
width: 58px;
display: inline-block;
`

const DivLogo = styled.div`
@media only screen and (min-width: 1024px) {
  // float: right;
  width: 100%;
  display: none;
}
margin: 8px !important;
display: inline-block;
filter: brightness(0) invert(1);
@media only screen and (max-width: 640px) {
  display: none;
}

`

const DivMiniLogo = styled.div`
@media only screen and (min-width: 1024px) {
  // float: right;
  width: 100%;
  display: none;
}

margin: 8px !important;
display: inline-block;



&#mobile_mini_logo_only_xs {
  display: none;
}

@media only screen and (max-width: 640px) {
  display: none;
  &#mobile_mini_logo_only_xs {
    display: inline-block;
  }
}

`

const ImgLogo = styled.img`
// top: 0;
// bottom: 0;
// left: 14px;

// position: absolute;
// width: 55%;
margin: auto;
vertical-align: middle;

object-fit: contain;
object-position: left;
height: auto;
max-height: 45px;
display: inline-block;
`
const ImgMiniLogo = styled.img`
vertical-align: middle;
object-fit: contain;
object-position: center;
width: 42px;
height: auto;
display: inline-block;
`

function BurgerButtonButton() {
  return (
    <BurgerButtonBg>
      <div
        role="button"
        onKeyDown={(e) => {if (e.key === 'Enter') {
          try {
            document.getElementById('react-burger-menu-btn').click();
          } catch (error) {
            console.error(error)
          }
        }}}
        onClick={() => {
          try {
            document.getElementById('react-burger-menu-btn').click();
          } catch (error) {
            console.error(error)
          }
        }}
        tabIndex="0"
      >
        <img
              alt="Open menu"
              src={"/icons/hamburger_white.svg"}
              className="img-hamburger-menu"
              style={{
                width: '70%',
                height: '70%',
                margin: '15%'
              }}
        />
      </div>
      <SideBar isOpen={ false }/>
    </BurgerButtonBg>
  )
}
function HomeLink({isOnlyMiniLogo}) {

  return (
    <Link
      duration={1}
      bg="#ffffff"
      to="/"
      rel="home"
    >
      {/* {JSON.stringify(isOnlyMiniLogo)} */}
      {
        isOnlyMiniLogo ? (
          <DivMiniLogo
            id="mobile_mini_logo"
            className="mag_header_vertical_mini_logo"
            style={{
              margin: "14px",
            }}
            >
            <ImgMiniLogo src={"/icons/small_logo.png"} alt={"Torna alla home"}/>
          </DivMiniLogo>
        ) : (
          <DivLogo
            id="mobile_logo"
            className="mag_header_vertical_logo"
            // style={{
            //   filter: 'brightness(0) invert(1)',
            // }}
          >
            <ImgLogo src={"/img/logo_startupitalia@2x.png"} alt={"Torna alla home"}/>
          </DivLogo>
        )

      }
      <DivMiniLogo
          id="mobile_mini_logo_only_xs"
          className="mag_header_vertical_mini_logo" style={{
            margin: "8px",
          }}
        >
        <ImgMiniLogo src={"/icons/small_logo.png"} alt={"Torna alla home"}/>
      </DivMiniLogo>
    </Link>
  );
}

function Header ({ vertical }) {

  const thisComponentRef = useRef();
  // const homeLinkRef = useRef();

  // const [onlyMiniLogo, setOnlyMiniLogo] = useState(true);
  const [menuPath, setMenuPath] = useState('.....');
  const [isArticle, setIsArticle] = useState(true);
  const [isVertical, setIsVertical] = useState(false);
  const [isSearch, setIsSearch] = useState(false);

  var array = [
    "menu_desk_tech",
    "menu_desk_economy",
    "menu_desk_education",
    "menu_desk_lifestyle",
    "menu_desk_startup",
    "menu_desk_impact",
    "menu_desk_agenda",
    "menu_desk_bandi",
    "menu_desk_life",
    "menu_desk_valoreresponsabile",
    "menu_desk_smartmoney",
    "menu_desk_unstoppablewomen"
  ]

  function overwrite_if_vertical(vertical, menupath) {
    //Settings for post on branded vertical
    if (vertical === "life") {
      menupath = "life";
    } else if (vertical === "valoreresponsabile") {
      menupath = "valoreresponsabile";
    } else if (vertical === "smartmoney") {
      menupath = "smartmoney";
    }
  }

  function manageBackgroundOpacity() {
    var min=100;
    var max=200;

    // console.log('vertical', vertical);

    let menupath = window.location.pathname.replace(/\//g,"");
    if (menupath === '') {
      min = 100;
      max = 250;
    }
    if (["search"].includes(menupath)) {
      if (thisComponentRef.current)
        thisComponentRef.current.firstChild.style.background = "rgba(11,1,53,1)"
      return;
    }

    var perc = (window.scrollY-min)/(max-min);
    if (perc<0) perc = 0;
    if (perc>1) perc = 1;

    if (thisComponentRef.current && thisComponentRef.current.firstChild) {
      thisComponentRef.current.firstChild.style.background = 'rgba(11,1,53,' + perc + ')';
      if (thisComponentRef.current.firstChild.firstChild && thisComponentRef.current.firstChild.firstChild.style) {
        thisComponentRef.current.firstChild.firstChild.style.opacity = perc;
      }
    }
  }

  function manageTextLogoOpacity() {
    var min=200;
    var max=300;

    // let menupath = window.location.pathname.replace(/\//g,"");
    // if (menupath === '') {
    //   min = 100;
    //   max = 250;
    // }

    var perc = (window.scrollY-min)/(max-min);
    if (perc<0) perc = 0;
    if (perc>1) perc = 1;
    // debugger;
    if (thisComponentRef.current) {
      let tmp = thisComponentRef.current.querySelector('#title-vertical-logo-container')
      if (tmp) {
        let titleLogoRef = tmp;
        if (titleLogoRef) {
          titleLogoRef.style.opacity = perc;
        }
      }
    }
    // titleLogoRef.firstChild.style.background = 'rgba(11,1,53,' + perc + ')';
    // if (thisComponentRef.current.firstChild.firstChild) {
    //   thisComponentRef.current.firstChild.firstChild.style.opacity = perc;
    // }
  }

  function manageScroll() {
    manageBackgroundOpacity();
    manageTextLogoOpacity();
  }

  useLayoutEffect(()=>{
    // let menupath = window.location.pathname.replace(/\//g,"");

    // overwrite_if_vertical(vertical, menupath);

    // setMenuPath(menupath);

    // if (['', 'my', 'option', 'about-us'].includes(menupath) ||
    //   ['tech', 'economy', 'education', 'impact', 'startup', 'lifestyle'].includes(menupath) ||
    //   false
    //   // TODO: add autori and not vertical article
    // ) {
    //   setOnlyMiniLogo(true);
    // }
    window.addEventListener("scroll", () => {
      manageScroll();
    }, false);
    manageBackgroundOpacity();
    return () => {
      window.removeEventListener("scroll", manageScroll);
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [])

  useLayoutEffect(()=>{
    let menupath = window.location.pathname.replace(/\//g,"");

    overwrite_if_vertical(vertical, menupath);
    setIsVertical(
      ['life', 'valoreresponsabile', 'smartmoney'].includes(vertical)
      ||
      ['life', 'valoreresponsabile', 'smartmoney'].includes(menupath)
    )

    setMenuPath(menupath);

    if (menupath !== "/" && array.includes('menu_desk_'+menupath) ) {
      setIsArticle(false);
    } else {
      setIsArticle(true);
    }

    setIsSearch(["search"].includes(menupath))

    // if (['', 'my', 'option', 'about-us'].includes(menupath) ||
    //   ['tech', 'economy', 'education', 'impact', 'startup', 'lifestyle'].includes(menupath) ||
    //   false
    //   // TODO: add autori and not vertical article
    // ) {
    //   setOnlyMiniLogo(true);
    // }
    // window.addEventListener("scroll", () => {
    //   manageScroll();
    // }, false);
    // manageBackgroundOpacity();
    // return () => {
    //   window.removeEventListener("scroll", manageScroll);
    // }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  let vertical_logos = {
    'life': "url(https://cdn.startupitalia.eu/wp-content/uploads/2020/12/02000333/Pasteur_CMJN.ai_.png)",
    'valoreresponsabile': "url(https://cdn.startupitalia.eu/wp-content/uploads/sites/20/2020/12/29131645/mediobanca-1.png)",
    'smartmoney': "url(https://cdn.startupitalia.eu/wp-content/uploads/sites/7/2015/02/illimity-logo-1.png)",
  }
  let vertical_text = {
    'life': "life",
    'valoreresponsabile': "valore responsabile",
    'smartmoney': "smart money",
  }

  return (
    <StaticQuery
      query={HEADER_QUERY}
      render={data => {
      return (
        <HeaderContainerDiv ref={thisComponentRef}>
          <header
            id="masthead"
            className={
              "site-header" +
              (isVertical ? ' is-vertical' : ' not-is-vertical') +
              (isArticle ? ' is-article' : ' not-is-article') +
              (isSearch ? ' is-search' : ' not-is-search')
            }
          >
            {
              (isSearch) ?
                <HomeLink isOnlyMiniLogo={false} /> :
                ""
            }
            {
              (!isSearch && (!isVertical || (isVertical && isArticle) || (isVertical && !isArticle))) ?
                <HomeLink isOnlyMiniLogo={isVertical} /> :
                ""
            }
            {/* {JSON.stringify(isVertical)} {JSON.stringify(isArticle)} */}
            <div
              id="title-vertical-logo-container"
              // style={{
              //   display: (isArticle) ? 'none' : 'flex'
              // }}
            >
              <div>
                {
                  (isVertical) ?
                    (
                      (isArticle) ? vertical_text[vertical] : vertical_text[menuPath]
                    ) : menuPath
                }
              </div>
              <div>
                {(isVertical) ?
                  <div className='vertical-logo' style={{
                    backgroundImage: (isArticle) ? vertical_logos[vertical] : vertical_logos[menuPath]
                  }}></div> :
                  ""
                }
                {/* {vertical_logos[vertical]} */}
              </div>
            </div>

            <BurgerButtonButton className="burger-button"/>

          </header>
        </HeaderContainerDiv>
      )
    }}
  />
  )
}

// function Header ({ vertical }) {

//   // const [isMenuOpen, setIsMenuOpen] = useState();
//   /*const Header = props => {
//     const {
//       vertical: { vertical },
//     } = props*/


//     //alert(vertical);


//     //console.log("props: "+props);
//     //console.log(props);

//   var array = [
//     "menu_desk_tech",
//     "menu_desk_economy",
//     "menu_desk_education",
//     "menu_desk_lifestyle",
//     "menu_desk_startup",
//     "menu_desk_impact",
//     "menu_desk_agenda",
//     "menu_desk_bandi",
//     "menu_desk_life",
//     "menu_desk_valoreresponsabile",
//     "menu_desk_smartmoney",
//     "menu_desk_unstoppablewomen"
//   ]


//   function overwrite_if_vertical(vertical, menupath) {
//     //Settings for post on branded vertical
//     if (vertical === "life") {
//       menupath = "life";
//     } else if (vertical === "valoreresponsabile") {
//       menupath = "valoreresponsabile";
//     } else if (vertical === "smartmoney") {
//       menupath = "smartmoney";
//     }
//   }

//   function myScript(article, minFont) {
//     // return;
//     //document.getElementsByClassName('mag_header_vertical')[0].style.fontSize="20px";
//     var header_scroll_opacity = true
//     var menupath = window.location.pathname.replace(/\//g,"")
//     var menupathori = menupath
//     var title_scrollonmove = true;

//     //alert(vertical)

//     overwrite_if_vertical(vertical, menupath);

//     if (["life", "valoreresponsabile", "smartmoney"].includes(menupathori)) {
//       title_scrollonmove = false;
//     }

//     if (menupath !== menupathori) {
//       header_scroll_opacity = false
//     }


//     var min=50;
//     var max=150;

//     var minTop=110;
//     var maxTop=3;

//     var minLeft=-34;
//     var maxLeft=8;

//     var minFontSize=minFont?minFont:25;
//     var maxFontSize=50;

//     var perc = (window.scrollY-min)/(max-min);
//     if (perc<0) perc = 0;
//     if (perc>1) perc = 1;
//     // console.log('myScript perc:'+perc);
//     //console.log('margin_top:'+parseInt((76-13)*perc)+"px");

//     var top_y_logo = 95;
//     var top_y_max_logo = 33;
//     var opa = ((window.scrollY-top_y_logo)/(top_y_max_logo-top_y_logo));
//     if (opa<0) opa = 0;
//     if (opa>1) opa = 1;

//     if (!header_scroll_opacity) {
//       opa = 1
//       perc = 1
//     }

//     if (article === true) {
//       perc=1;
//       opa=0;
//     }


//     var marginTop=parseInt(minTop-((minTop-maxTop)*(title_scrollonmove?perc:1)))+"px";

//     var marginTopUnderline=parseInt(minTop+36-((minTop-maxTop)*perc))+"px";
//     var marginLeft=parseInt(minLeft-((minLeft-maxLeft)*(title_scrollonmove?perc:1)))+"px";

//     if (
//         document.getElementsByClassName('mag_header_vertical_mini_title') &&
//         document.getElementsByClassName('mag_header_vertical_mini_title')[0]) {
//       let miniTitleEl = document.getElementsByClassName('mag_header_vertical_mini_title')[0];
//       //if (document.getElementsByClassName('mag_header_vertical_mini_title')[0].style.marginTop != marginTop) {
//       miniTitleEl.style.marginTop = marginTop;
//       miniTitleEl.style.marginLeft = marginLeft;
//       document.getElementsByClassName('mag_header_vertical_mini_title_underline')[0].style.marginTop = marginTopUnderline;

//       document.getElementsByClassName('mag_header_vertical_mini_title_underline')[0].style.opacity = 1 - perc * 2;

//       // console.log("scroll on menupath "+menupath);
//       // if (menupath === "life") {
//       if (["life", "valoreresponsabile", "smartmoney"].includes(menupath)) {
//         if (window.scrollY > 200) {
//           document.getElementById('header_overlay_desk_brand').style.display = "inline";
//         } else {
//           document.getElementById('header_overlay_desk_brand').style.display = "none";
//         }
//         miniTitleEl.style.opacity = perc * 2;
//       } else {
//         document.getElementById('header_overlay_desk_brand').style.display = "none";
//         miniTitleEl.style.opacity = 1;
//       }

//       if (
//           menupath !== "/" &&
//           array.includes('menu_desk_'+ menupath) &&
//           menupath !== "option" &&
//           menupath !== "my"
//         ) {
//         //alert('grandient '+perc)
//         document.getElementsByClassName('mag_header_vertical')[0].style.fontSize = maxFontSize-((maxFontSize-minFontSize)*(header_scroll_opacity && title_scrollonmove? perc : 1))+"px";

//         if (header_scroll_opacity){
//           document.getElementsByClassName('site-header')[0].style.background = "linear-gradient(rgba(11,1,53,"+(0+perc)+"), rgba(11,1,53,"+(0+perc)+"))";
//         } else{
//           document.getElementsByClassName('site-header')[0].style.background = "linear-gradient(rgba(11,1,53,1), rgba(11,1,53,1)";
//         }
//       }
//     }
//   } //onScroll end


//   //var old_path = "";
//   useLayoutEffect(()=>{
//     console.log('Header useLayoutEffect up');

//     document.getElementById('mag_desktop_sidebar').style.visibility = "visible";

//     document.getElementById('burger_menu').style.visibility = "visible";

//     document.getElementById('home_logo_desktop').style.visibility = "visible";
//     //alert('update mobile_logo')

//     var menupath = window.location.pathname.replace(/\//g,"")
//     var menupathori = window.location.pathname.replace(/\//g,"")
//     var header_scroll_opacity = true;

//     overwrite_if_vertical(vertical, menupath);

//     if (menupath !== menupathori) {
//       // L'header fisso dei branded NOME LOGO per i post
//       // deve essere subito presente e non fare l'animazione
//       header_scroll_opacity = false
//     }

//     //window.alert("menu "+menupath);
//     // var listener;

//     if (menupath !== "/" && array.includes('menu_desk_'+menupath) ) {

//       window.addEventListener("scroll", function(){
//         myScript(false, menupath==="valoreresponsabile" || menupath==="smartmoney"?11:null);
//       }, false);

//       if (document.getElementsByClassName('mag_header_vertical_mini_title') && document.getElementsByClassName('mag_header_vertical_mini_title')[0]) {
//         if (menupath !== "" && array.includes('menu_desk_'+menupath)) {

//           if (menupath === "life") {
//             //background: "url(https://cdn.startupitalia.eu/wp-content/uploads/2020/12/02000333/Pasteur_CMJN.ai_.png)"
//             document.getElementById('brand_logo_overlay').style.backgroundImage = "url(https://cdn.startupitalia.eu/wp-content/uploads/2020/12/02000333/Pasteur_CMJN.ai_.png)";
//             document.getElementById('brand_logo').style.backgroundImage = "url(https://cdn.startupitalia.eu/wp-content/uploads/2020/12/02000333/Pasteur_CMJN.ai_.png)";
//             document.getElementById('brand_logo').style.backgroundPosition= "center";
//             document.getElementById('brand_logo').style.backgroundSize= "contain";
//             document.getElementById('brand_logo').style.backgroundRepeat= "no-repeat";
//             document.getElementById('brand_logo').style.display = "block"

//             document.getElementsByClassName('mag_header_vertical_mini_title')[0].style.opacity = 0;
//             document.getElementsByClassName('mag_header_vertical')[0].innerHTML = "LIFE";
//             document.getElementsByClassName('header_overlay_desk_brand_title')[0].innerHTML = "LIFE";

//           } else if (menupath === "valoreresponsabile") {
//             //background: "url(https://cdn.startupitalia.eu/wp-content/uploads/2020/12/02000333/Pasteur_CMJN.ai_.png)"
//             document.getElementById('brand_logo_overlay').style.backgroundImage = "url(https://cdn.startupitalia.eu/wp-content/uploads/sites/20/2020/12/29131645/mediobanca-1.png)";
//             document.getElementById('brand_logo').style.backgroundImage = "url(https://cdn.startupitalia.eu/wp-content/uploads/sites/20/2020/12/29131645/mediobanca-1.png)";
//             document.getElementById('brand_logo').style.backgroundPosition= "center";
//             document.getElementById('brand_logo').style.backgroundSize= "contain";
//             document.getElementById('brand_logo').style.backgroundRepeat= "no-repeat";
//             document.getElementById('brand_logo').style.display = "block"
//             document.getElementsByClassName('mag_header_vertical_mini_title')[0].style.opacity = 0;
//             document.getElementsByClassName('mag_header_vertical')[0].innerHTML = "VALORE RESPONSABILE";
//             document.getElementsByClassName('header_overlay_desk_brand_title')[0].innerHTML = "VALORE RESPONSABILE";
//           } else if (menupath === "smartmoney") {
//             //alert("life");
//             //if (document.getElementsByClassName('mag_header_vertical_mini_title')[0].style.opacity != 1-opa) {
//             document.getElementsByClassName('mag_header_vertical_mini_title')[0].style.opacity = 0;
//             document.getElementById('brand_logo_overlay').style.backgroundImage = "url(https://cdn.startupitalia.eu/wp-content/uploads/sites/7/2015/02/illimity-logo-1.png)";
//             document.getElementById('brand_logo').style.backgroundImage = "url(https://cdn.startupitalia.eu/wp-content/uploads/sites/7/2015/02/illimity-logo-1.png)";
//             document.getElementById('brand_logo').style.backgroundPosition= "center";
//             document.getElementById('brand_logo').style.backgroundSize= "contain";
//             document.getElementById('brand_logo').style.backgroundRepeat= "no-repeat";
//             document.getElementById('brand_logo').style.display = "block"
//             //document.getElementsByClassName('mag_header_vertical')[0].innerHTML = "VALORE RESPONSABILE";
//             document.getElementsByClassName('header_overlay_desk_brand_title')[0].innerHTML = "SMART MONEY";
//             //}
//           } else {
//             document.getElementsByClassName('mag_header_vertical_mini_title')[0].style.opacity = 1;
//             document.getElementsByClassName('mag_header_vertical')[0].innerHTML = menupath;
//           }

//           if (menupath === "unstoppablewomen") {
//             document.getElementsByClassName('mag_header_vertical')[0].classList.add("mag_header_vertical_long");
//           }

//           document.getElementById('header_overlay_desk_brand').style.display = "none";

//           document.getElementsByClassName('mag_header_vertical_mini_title')[0].style.display = "inline-block";
//           //}
//           // document.getElementsByClassName('site-main')[0].style.marginTop = '-10px';
//           document.getElementsByClassName('mag_header_vertical_mini_logo')[0].style.display = "inline-block";
//           document.getElementsByClassName('mag_header_vertical')[0].style.textTransform = "uppercase";

//           //alert('site-header colorato')
//           if (header_scroll_opacity)
//           document.getElementsByClassName('site-header')[0].style.background = "linear-gradient(rgba(11,1,53,0), rgba(11,1,53,0)";
//           else
//           document.getElementsByClassName('site-header')[0].style.background = "linear-gradient(rgba(11,1,53,1), rgba(11,1,53,1)";

//           //window.alert(document.getElementsByClassName('mag_header_vertical_mini_title')[0].offsetWidth);
//           if (menupath !== "life" && menupath !== "valoreresponsabile" && menupath !== "smartmoney") {
//             document.getElementById('brand_logo').style.display= "none";
//             document.getElementsByClassName('mag_header_vertical_mini_title_underline')[0].style.display = "block";
//           } else {
//             document.getElementsByClassName('mag_header_vertical_mini_title_underline')[0].style.display = "none";
//           }

//           document.getElementsByClassName('mag_header_vertical_mini_title_underline')[0].style.width = document.getElementsByClassName('mag_header_vertical')[0].offsetWidth+"px";
//           document.getElementsByClassName('mag_header_vertical_mini_title_underline')[0].style.backgroundColor = (new CategoryColor(menupath).color);
//           //}
//           //}
//           //window.onscroll = function() {myFunction()};

//         } else {
//           let color_mode;
//           if (localStorage.getItem("font_color_mode")===null) {
//             //Se non è impostato dall'utente imposto il dark mod in base
//             //al tema del computer/smartphone, solo su safari
//             if(window.matchMedia('(prefers-color-scheme: dark)').matches){
//               color_mode = "dark";
//             } else {
//               color_mode = "";
//             }
//           } else {
//             color_mode = localStorage.getItem('font_color_mode')?localStorage.getItem('font_color_mode'):"";
//           }

//           //if (document.getElementsByClassName('site-header')[0].style.background != color_mode === ""? "#FFFFFF" : "#2e2e2e" )
//           //{
//           //alert('sbianco 2')
//           document.getElementsByClassName('site-header')[0].style.background = color_mode === ""? "#FFFFFF" : "#2e2e2e";
//           //}
//           document.getElementById('brand_logo').style.display = "none"
//           /*if (window.innerWidth<500) {
//             document.getElementsByClassName('site-main')[0].style.marginTop = '53px';
//           } else {
//             document.getElementsByClassName('site-main')[0].style.marginTop = '13px';
//           }

//           document.getElementsByClassName('mag_header_vertical_logo')[0].style.display = "block"
//           document.getElementsByClassName('mag_header_vertical_mini_title')[0].style.display = "none";
//           document.getElementsByClassName('mag_header_vertical_mini_logo')[0].style.display = "none";
//           document.getElementsByClassName('mag_header_vertical_mini_title_underline')[0].style.display = "none";
//           */
//         }
//       }
//     } else {

//       document.getElementsByClassName('mag_header_vertical_mini_logo')[0].style.visibility = "hidden";


//       myScript(false, null);
//       //alert('ssss')
//       //alert('update')
//       if (document.getElementsByClassName('mag_header_vertical_mini_title') && document.getElementsByClassName('mag_header_vertical_mini_title')[0]) {
//         if (menupath !== "" && array.includes('menu_desk_'+menupath)) {
//           //alert("due "+menupath)
//           //document.getElementsByClassName('site-header')[0].style.background = "linear-gradient(rgba(11,1,53,0), rgba(11,1,53,0))";
//           //if (document.getElementsByClassName('mag_header_vertical_logo')[0].style.display != "none") {
//           document.getElementsByClassName('mag_header_vertical_logo')[0].style.display = "none";

//           //if (menupath !== "life") {
//           if (menupath === "life") {
//             //background: "url(https://cdn.startupitalia.eu/wp-content/uploads/2020/12/02000333/Pasteur_CMJN.ai_.png)"
//             let brandLogoEl = document.getElementById('brand_logo');
//             brandLogoEl.style.backgroundImage = "url(https://cdn.startupitalia.eu/wp-content/uploads/2020/12/02000333/Pasteur_CMJN.ai_.png)";
//             brandLogoEl.style.backgroundPosition= "center";
//             brandLogoEl.style.backgroundSize= "contain";
//             brandLogoEl.style.backgroundRepeat= "no-repeat";
//             brandLogoEl.style.display = "block"
//             document.getElementsByClassName('mag_header_vertical_mini_title')[0].style.opacity = 0;
//             document.getElementsByClassName('mag_header_vertical')[0].innerHTML = "LIFE";
//           } else if (menupath === "valoreresponsabile") {
//             //background: "url(https://cdn.startupitalia.eu/wp-content/uploads/2020/12/02000333/Pasteur_CMJN.ai_.png)"
//             let brandLogoEl = document.getElementById('brand_logo');
//             brandLogoEl.style.backgroundImage = "url(https://cdn.startupitalia.eu/wp-content/uploads/sites/20/2020/12/29131645/mediobanca-1.png)";
//             brandLogoEl.style.backgroundPosition= "center";
//             brandLogoEl.style.backgroundSize= "contain";
//             brandLogoEl.style.backgroundRepeat= "no-repeat";
//             brandLogoEl.style.display = "block"
//             document.getElementsByClassName('mag_header_vertical_mini_title')[0].style.opacity = 0;
//             document.getElementsByClassName('mag_header_vertical')[0].innerHTML = "VALORE RESPONSABILE";

//           } else if (menupath === "smartmoney") {
//             //background: "url(https://cdn.startupitalia.eu/wp-content/uploads/2020/12/02000333/Pasteur_CMJN.ai_.png)"
//             let brandLogoEl = document.getElementById('brand_logo');
//             brandLogoEl.style.backgroundImage = "url(https://cdn.startupitalia.eu/wp-content/uploads/sites/7/2015/02/illimity-logo-1.png)";
//             brandLogoEl.style.backgroundPosition= "center";
//             brandLogoEl.style.backgroundSize= "contain";
//             brandLogoEl.style.backgroundRepeat= "no-repeat";
//             brandLogoEl.style.display = "block"
//             document.getElementsByClassName('mag_header_vertical_mini_title')[0].style.opacity = 0;
//             document.getElementsByClassName('mag_header_vertical')[0].innerHTML = "SMART MONEY";

//           } else {
//             document.getElementsByClassName('mag_header_vertical')[0].innerHTML = menupath;
//           }

//           document.getElementsByClassName('mag_header_vertical_mini_title')[0].style.display = "inline-block";
//           //}
//           // document.getElementsByClassName('site-main')[0].style.marginTop = '-10px';
//           document.getElementsByClassName('mag_header_vertical_mini_logo')[0].style.display = "inline-block";
//           document.getElementsByClassName('mag_header_vertical')[0].style.textTransform = "uppercase";

//           //alert('site-header colorato')
//           if (header_scroll_opacity)
//           document.getElementsByClassName('site-header')[0].style.background = "linear-gradient(rgba(11,1,53,0), rgba(11,1,53,0)";
//           else
//           document.getElementsByClassName('site-header')[0].style.background = "linear-gradient(rgba(11,1,53,1), rgba(11,1,53,1)";


//           //window.alert(document.getElementsByClassName('mag_header_vertical_mini_title')[0].offsetWidth);
//           if (menupath !== "life" && menupath !== "valoreresponsabile" && menupath !== "smartmoney") {
//             document.getElementById('brand_logo').style.display= "none";
//             document.getElementsByClassName('mag_header_vertical_mini_title_underline')[0].style.display = "block";
//           }
//           document.getElementsByClassName('mag_header_vertical_mini_title_underline')[0].style.width = document.getElementsByClassName('mag_header_vertical')[0].offsetWidth+"px";
//           document.getElementsByClassName('mag_header_vertical_mini_title_underline')[0].style.backgroundColor = (new CategoryColor(menupath).color);
//           //}
//           //}
//           //window.onscroll = function() {myFunction()};

//         } else {
//           //window.removeEventListener("scroll", myScript);

//           document.getElementsByClassName('mag_header_vertical_mini_title')[0].style.display = "none";
//           document.getElementsByClassName('mag_header_vertical_mini_title_underline')[0].style.display = "none";
//           let color_mode;
//           if (localStorage.getItem("font_color_mode")===null) {
//             //Se non è impostato dall'utente imposto il dark mod in base
//             //al tema del computer/smartphone, solo su safari
//             if(window.matchMedia('(prefers-color-scheme: dark)').matches){
//               color_mode = "dark";
//             } else {
//               color_mode = "";
//             }
//           } else {
//             color_mode = localStorage.getItem('font_color_mode')?localStorage.getItem('font_color_mode'):"";
//           }

//           document.getElementsByClassName('site-header')[0].style.background = color_mode === ""? "#FFFFFF" : "#2e2e2e";

//           document.getElementById('brand_logo').style.display = "none"

//         }
//       }


//     }

//     return () => {
//       console.log('Header useLayoutEffect down');
//       //if (menupath !== "/" && array.includes('menu_desk_'+menupath) ) {
//       window.removeEventListener("scroll", function(){
//         myScript(
//           false,
//           menupath==="valoreresponsabile" || menupath==="smartmoney" ? 11 : null
//           );
//         }, false);
//         //}
//       };
//     }
//   );


//   return (
//     <StaticQuery
//       query={HEADER_QUERY}
//       render={data => {
//       return (
//         <div>
//           <div
//             id="header_overlay_desk_brand"
//             className="header_overlay_desk_brand"
//             style={{
//               opacity: 1,
//               position: "fixed",
//               marginLeft: "17%",
//               left:0,
//               zIndex: 999,
//               top:0,
//               right:0,
//               boxSizing: "border-box",
//               height: "29px",
//               backgroundColor: "#17102B"
//             }}
//           >
//             <div
//               className="header_overlay_desk_brand_title"
//               style={{
//                 marginLeft: "5px",
//                 fontFamily: "aktiv-grotesk",
//                 height: "29px",
//                 fontSize: "15px",
//                 letterSpacing: "-0.4px",
//                 lineHeight: "29px",
//                 fontWeight: 900,
//                 width: "50%",
//                 color: "white",
//                 float: "left"
//               }}
//             >
//               SMART MONEY
//             </div>
//             <div style={{width: "fit-content", float: "right", color: "white"}}>
//               <div id="brand_logo_overlay" className="mag_img_brand_logo_overlay" style={{
//                 filter: "brightness(0) invert(1)",
//                 backgroundSize: "contain",
//                 width: "145px",
//                 height: "29px",
//                 backgroundRepeat: "no-repeat",
//                 float: "left",
//                 marginRight:"20px",
//                 backgroundPosition: "center"}}>
//               </div>
//             </div>
//           </div>
//           <header id="masthead" className="site-header">

//             <HomeLink />
//             <div
//             className="mag_header_vertical_mini_title"
//             style={{
//               // display: "none",
//               // float: "left",
//               // marginLeft: "-34px",
//               // width: "255px",
//               alignItems: "center"
//             }}
//             >
//               <div
//                 className="mag_header_vertical"
//                 style={{
//                   fontWeight: "900",
//                   display: "flex",
//                   height: "55px",
//                   justifyContent: "center",
//                   flexDirection: "column",
//                   float:"left",
//                   width: "86px",
//                   lineHeight: "18px",
//                   marginRight:"10px"
//                 }}>
//               </div>
//               <div
//                 id="brand_logo"
//                 className="mag_img_brand_logo"
//                 style={{
//                   filter: "brightness(0) invert(1)",
//                   backgroundSize: "contain",
//                   width: "145px",
//                   height: "55px",
//                   backgroundRepeat: "no-repeat",
//                   float: "left",
//                   display:"none",
//                   backgroundPosition: "center"
//                 }}
//               >
//               </div>
//             </div>
//             {/* <div
//               className="mag_header_vertical_mini_title_underline"
//               style={{
//                 display: "none",
//                 position: "absolute",
//                 height: "20px",
//                 width: "303px",
//                 backgroundColor: "#EF767E",
//                 marginTop: "149px",
//                 marginLeft: "40px",
//                 zIndex: "-1"
//               }}
//             /> */}

//             <BurgerButtonButton/>

//           </header>
//         </div>
//       )
//     }}
//   />
//   )
// }

export default Header
//export default Header
